import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import './ShopBase.css';
import star from '../assets/star.png';

function CompletedChores() {
  const { user } = useParams();
  const navigate = useNavigate();

  const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000';
  const other = user === 'rija' ? 'sree' : 'rija';

  const [chores, setChores] = useState([]);
  const [points, setPoints] = useState(0);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const [toggledChores, setToggledChores] = useState({});

  const [modal, setModal] = useState({
    open: false,
    message: '',
    onConfirm: null,
    item: null,
  });

  // =========================
  // Fetch chores + points
  // =========================
  const fetchAll = async () => {
    try {
      const [choresRes, pointsRes] = await Promise.all([
        fetch(`${API_URL}/users/${other}/completed_chores`),
        fetch(`${API_URL}/users/${other}/points`),
      ]);

      const choresData = await choresRes.json();
      const pointsData = await pointsRes.json();

      setChores(choresData.completed_chores || []);
      setPoints(pointsData.points || 0);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchAll();
  }, [user, other]);

  // =========================
  // Toggle handler
  // =========================
  const handleToggle = (chore) => {
    const id = chore.choreCompleteId;

    if (!toggledChores[id]) {
      setModal({
        open: true,
        message: 'Confirm Chore Completion?',
        item: chore,
        onConfirm: () => acknowledgeChore(chore),
      });
    } else {
      setToggledChores((prev) => ({
        ...prev,
        [id]: false,
      }));
    }
  };

  // =========================
  // Acknowledge chore
  // =========================
  const acknowledgeChore = async (chore) => {
    try {
      const res = await fetch(
        `${API_URL}/chores/${other}/acknowledge/${chore.completeId}`,
        { method: 'POST' }
      );

      if (!res.ok) throw new Error();

      await fetchAll(); // refresh chores + points
    } catch {
      alert('Something went wrong');
    } finally {
      setModal((m) => ({ ...m, open: false }));
    }
  };

  // =========================
  // Render guards
  // =========================
  if (loading) return <div className="modal">Loading...</div>;
  if (error) return <div className="modal error">Error: {error}</div>;

  return (
    <div className="shop-base" style={{ background: '#f0f0f0', paddingBottom: '80px' }}>
      {/* Title bar */}
      <div className="shop-title-bar">
        <h1 className="shop-title">
          {other.charAt(0).toUpperCase() + other.slice(1)}'s Completed Chores
        </h1>

        <div className="points">
          <img src={star} alt="star" className="points-star" />
          <span className="points-value">{points}</span>
        </div>
      </div>

      {/* Content */}
      <div className="shop-content">
        <div
          className="panel chores"
          style={{ background: '#f0fff0', borderColor: '#6ccf8e' }}
        >
          <h2 className="panel-title" style={{ color: '#6ccf8e' }}>
            Completed Chores
          </h2>

          <ul>
            {chores.length > 0 ? (
              chores.map((c) => (
                <li key={c.choreCompleteId}>
                  <span className="item-text">{c.choreDesc}</span>
                  <span className="item-cost">+{c.choreCost}</span>

                  <label className="toggle-switch">
                    <input
                      type="checkbox"
                      checked={!!toggledChores[c.choreCompleteId]}
                      onChange={() => handleToggle(c)}
                    />
                    <span className="slider"></span>
                  </label>
                </li>
              ))
            ) : (
              <li className="empty">No completed chores</li>
            )}
          </ul>
        </div>
      </div>

      {/* Confirm modal */}
      {modal.open && (
        <div className="confirm-modal-overlay">
          <div className="confirm-modal">
            <p className="confirm-message">{modal.message}</p>
            <div className="confirm-buttons">
              <button
                className="confirm-yes"
                onClick={() => {
                  modal.onConfirm();
                  setToggledChores((prev) => ({
                    ...prev,
                    [modal.item.choreCompleteId]: true,
                  }));
                }}
              >
                Yes
              </button>
              <button
                className="confirm-no"
                onClick={() => {
                  setToggledChores((prev) => ({
                    ...prev,
                    [modal.item.choreCompleteId]: false,
                  }));
                  setModal((m) => ({ ...m, open: false }));
                }}
              >
                No
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Back */}
      <button className="redeemed-btn" onClick={() => navigate(-1)}>
        Back
      </button>
    </div>
  );
}

export default CompletedChores;
